import jsx from "babel-plugin-syntax-jsx"

// 教务 移动端 切换班级 指令
export default {
  install() {
    let switchClassChange = []
    let url = "/classes/findTeacherClassesList"
    let title = "选择班次";
    let defaultClassInfo = {
      branchId: '',
      name: '',
      branchName: '',
      classId: ''
    }
    let switchClassBox = null
    let selectEl = null

    function init() {
      if (switchClassBox) return switchClassBox.getClassList(true)
      selectEl = document.createElement('div')
      selectEl.setAttribute('class', 'mobile mobile-panel-select-box')
      selectEl.innerHTML = `
        <van-popup
          v-model="showPicker"
          position="bottom"
          :style="{ height: '100%' }"
        >
          <div :style="DivStyle">
            <p :style="titleStyle">{{ vanPopupTitle }}</p>
            <p :style="PStyle" @click="ClickHandle('close')">关闭</p>
          </div>
          <van-tree-select
            :items="VantreeItems"
            height="93%"
            :main-active-index.sync="activeIndex"
            :active-id="activeid"
            @click-nav="ClickHandle('nav', $event)"
            @click-item="ClickHandle('item', $event)"
          />
        </van-popup>
        `
      document.body.appendChild(selectEl)
      switchClassBox = new Vue({
        el: '.mobile-panel-select-box',
        data() {
          return {
            DivStyle: {
              height: "7%",
              width: "calc(100% - 0.32rem)",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              paddingRight: "0.32rem",
            },
            PStyle: {

            },
            titleStyle: {
              marginLeft: "0.32rem",
              fontSize: "0.35rem",
              color: "#333"
            },
            VantreeItems: [
              {
                text: "当前班次",
                children: []
              },
              {
                text: "未开始班次",
                children: []
              },
              {
                text: "历史班次",
                children: []
              }
            ],
            activeIndex: 0,
            classList: [],
            showPicker: false,
            defaultIndex: 0,
            activeid: "",
            vanPopupTitle: ""
          }
        },
        created() {
          this.vanPopupTitle = title || "";
        },
        mounted() {
          this.getClassList(true)
        },
        methods: {
          onChange(info) {
            let currentClassInfo = JSON.parse(JSON.stringify(defaultClassInfo))
            if (info.classId) currentClassInfo.classId = info.classId
            if (info.className) currentClassInfo.name = info.className
            dsf.storage.session.set("currentClassInfo", JSON.stringify(currentClassInfo), true)
            if (switchClassChange.length) {
              switchClassChange.map(change => change(currentClassInfo))
            }
            this.showPicker = false
          },
          showPickerFn() {
            this.getClassList()
          },
          updateDefaultIndex() {
            let currentClassInfo = this.classList[this.defaultIndex] || {}
            this.defaultIndex = this.classList.findIndex((info) => info.classId == currentClassInfo.classId)
          },
          getClassList(isInit) {
            dsf.http.get(url).then(({ data }) => {
              if (data && data.success) {
                let classList = this.classList = data.data || []
                // 置空数据，不然每打开一次，原来的数据依然存在，重复添加
                this.VantreeItems.forEach(value => {
                  value.children = [];
                });
                classList.forEach(n => this.VantreeItems[Number(n.classStatus) - 1].children.push({
                  text: n.className,
                  ...n
                }));

                let currentClassInfo = dsf.storage.session.get("currentClassInfo", JSON.stringify(defaultClassInfo), true)
                currentClassInfo = JSON.parse(currentClassInfo) || {};
                let index = classList.findIndex(info => info.classId == currentClassInfo.classId)
                if (index < 0) {
                  this.activeIndex = 0;
                  this.defaultIndex = 0
                } else {
                  this.activeIndex = Number(classList[index].classStatus) - 1;
                  this.defaultIndex = index;
                }
                let info = classList[this.defaultIndex] || {}
                if (isInit) this.onChange(info)
                if (!isInit) this.showPicker = true
              }
            })
          },
          ClickHandle(EventsName = null, e = null) {
            switch (EventsName) {
              case "close":
                this.showPicker = false;
                break;
              case "nav":
                this.activeIndex = Number(e);
                break;
              case "item":
                console.log(e);
                this.onChange(e);
                break;
            }
          }
        }
      })
    }

    function uninit() {
      if (selectEl) {
        document.body.removeChild(selectEl)
        selectEl = null
      }
      if (switchClassBox) {
        switchClassBox.$destroy()
        switchClassBox = null
      }
    }

    Vue.directive('mobileSwitchClass', {
      bind: function (el, binding, vnode, oldVnode) {
        // console.log("bind")
        let value = binding.value
        if (value) {
          if (value.url) url = value.url
          if (value.title != undefined) title = value.title
          value.change && switchClassChange.push(value.change)
        }
        init()
        el.onclick = function () {
          if (switchClassBox) switchClassBox.showPickerFn()
        }
      },
      componentUpdated: function () {
        // console.log("componentUpdated")
      },
      inserted: function () {
        // console.log("inserted")
      },
      update: function () {
        // console.log("update")
        if (switchClassBox) switchClassBox.updateDefaultIndex()
      },
      unbind: function () {
        // console.log("unbind")
        uninit()
      }
    })
  }
}
